import { fetchApiData, fetchApiDataV2 } from "../../utils/utils";

export const getPlayerToken = async (appInfo,id) => {
  const api = "playlistV2/generateToken";
  const params = {
    id : id
  }
  return await fetchApiDataV2(appInfo,api,params)
  };
  
  export const getVideoDetails = async (id,appInfo,showId) =>{
    const api =`video/details/${id}`
    const params = showId ? { show_id: showId } : null
    return await fetchApiDataV2(appInfo,api,params)
}
